import React, { FunctionComponent, Suspense, lazy } from "react";
import styles from "./IconViewer.module.scss";
import combineClasses from "helpers/combine-classes";
import IconViewerContent from "./IconViewer.interface";
import isBrowserContext from "helpers/isBrowserContext";

const Close = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Close"));
const Facebook = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Facebook"));
const Instagram = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Instagram"));
const LinkedIn = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/LinkedIn"));
const Twitter = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Twitter"));
const YouTube = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/YouTube"));
const Logo = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Logo"));
const ArrowDown = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/ArrowDown"));
const ArrowRight = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/ArrowRight"));
const ChevronDown = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/ChevronDown"));
const Play = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Play"));
const Pause = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Pause"));
const Mail = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Mail"));
const Phone = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Phone"));
const Search = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Search"));
const Download = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Download"));
const Smiley = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Smiley"));
const SoundOn = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/SoundOn"));
const SoundOff = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/SoundOff"));
const SmallArrowDown = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/SmallArrowDown"));
const Badge = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Badge"));
const Bagerrigt = lazy(() => import(/* webpackChunkName: "Icons" */ "./Icons/Bagerrigt"));

const ICON_TYPES: { [key: string]: any } = {
    // Static
    "close": Close,
    "facebook": Facebook,
    "instagram": Instagram,
    "linkedin": LinkedIn,
    "twitter": Twitter,
    "youtube": YouTube,
    "logo": Logo,
    "arrowDown": ArrowDown,
    "arrowRight": ArrowRight,
    "chevronDown": ChevronDown,
    "play": Play,
    "pause": Pause,
    "mail": Mail,
    "phone": Phone,
    "download": Download,
    "smiley": Smiley,
    "search": Search,
    "sound-on": SoundOn,
    "sound-off": SoundOff,
    "small-arrow-down": SmallArrowDown,
    "badge": Badge,
    "bagerrigt": Bagerrigt,
};

const IconViewer: FunctionComponent<IconViewerContent> = (props) => {
    const Icon = ICON_TYPES[props.name];

    return (
        <div className={combineClasses([styles.wrapper, props.className])}>
            <div
                className={styles.inner}
                style={{ paddingTop: `${((props.heightRatio || 1) * 100).toFixed(2)}%` }}
            >
                {isBrowserContext() ? <Suspense fallback={null}>{Icon ? <Icon className={styles.icon} /> : null}</Suspense> : null}
            </div>
        </div>
    );
};

export default IconViewer;
